/**
 * Intention: This store is used to track necessary and commonly accessed user settings
 * like current user language preferences etc
 */
export const useUserSettingsStore = defineStore('userSettings', {
  state(): { currentLanguage: string } {
    return {
      currentLanguage: useLocalize().getLanguage() ?? 'en',
    }
  },
  actions: {
    setLanguage(currentLanguage: string) {
      this.currentLanguage = currentLanguage
      useLocalize().setLanguage(currentLanguage)
    },
  },
})
